import { Component, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from 'src/app/_services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-chemistshop-layout',
  templateUrl: './chemistshop-layout.component.html',
  styleUrls: ['./chemistshop-layout.component.css']
})
export class ChemistshopLayoutComponent implements OnInit {

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset).pipe(map(result => result.matches));
  ecomNavItems = [];
  constructor(public authService: AuthService,
    private breakpointObserver: BreakpointObserver,
    private router: Router,
  ) { }

  ngOnInit() {
    this.ecomNavItems = [
      {
        displayName: 'TheChemistShop',
        iconName: 'local_mall',
        route: '/chemistshop',
      },
      {
        displayName: 'Ebay Orders',
        iconName: 'add_shopping_cart',
        route: 'chemistshop/ebay',
        children: [
          {
            displayName: 'Ebay Orders',
            iconName: 'star_rate',
            route: 'chemistshop/ebay/ebay-orders'
          },
          // {
          //   displayName: 'Order Details',
          //   iconName: 'star_rate',
          //   route: 'chemistshop/ebay/ebay-order-details'
          // }
        ]
      },
      {
        displayName: 'Groupon',
        iconName: 'add_shopping_cart',
        route: 'chemistshop/groupon',
        children: [
          {
            displayName: 'Groupon Orders',
            iconName: 'star_rate',
            route: 'chemistshop/groupon/groupon-orders'
          },
          // {
          //   displayName: 'Order Details',
          //   iconName: 'star_rate',
          //   route: 'chemistshop/groupon/groupon-order-details'
          // }
        ]
      },
      {
        displayName: 'On Buy',
        iconName: 'add_shopping_cart',
        route: 'chemistshop/onbuy',
        children: [
          {
            displayName: 'Onbuy Orders',
            iconName: 'star_rate',
            route: 'chemistshop/onbuy/onbuy-orders'
          },
          // {
          //   displayName: 'Order Details',
          //   iconName: 'star_rate',
          //   route: 'chemistshop/groupon/groupon-order-details'
          // }
        ]
      },
      {
        displayName: 'Shipstation',
        iconName: 'add_shopping_cart',
        route: 'chemistshop/shipstation',
        children: [
          {
            displayName: 'Shipstation Orders',
            iconName: 'star_rate',
            route: 'chemistshop/shipstation/shipstation-orders'
          },
          // {
          //   displayName: 'Order Details',
          //   iconName: 'star_rate',
          //   route: 'chemistshop/groupon/groupon-order-details'
          // }
        ]
      }
    ];
  }

  onOpenModule() {
    if ((this.authService.user_dept == 'school' || this.authService.user_dept == 'admin')) {
      this.router.navigateByUrl('/');
    }
  }

}

